// extracted by mini-css-extract-plugin
module.exports = {"logo":"EndCertificate_logo__2Ra-N"};